<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-26 16:14:03
-->
<template>
	<div class="mt-12 yx-form-wrap">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item label="团长昵称">
				<el-input v-model="formData['institutionName']" placeholder="请输入团长昵称" clearable></el-input>
			</el-form-item>
			<el-form-item label="机构id号">
				<el-input v-model="formData['number']" placeholder="请输入机构id号" clearable></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit">筛选</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
export default {
	name: 'search',
	data() {
		return {
			formData: {},
		};
	},
	props: {
		platformId: {
			type: [String, Number],
			default: dataMap.PLATFORM_DY.value,
		},
	},
	computed: {},
	methods: {
		onClear() {
			this.formData = {};
			this.onSubmit();
		},
		onSubmit: throttle(function () {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
};
</script>
